import { useAuth } from "hooks/useAuth";
import { Link } from "react-router-dom";
import { AdminList } from "types/User";

export function OptionInstabilityAlert() {
    const { user } = useAuth();

    if (user == null || !AdminList.includes(user.name)) {
        return (<div></div>);
    } else {
        return (
            <tr>
                <td>Alerta de instabilidade</td>
                <td><Link to={"/instability-alert"}>Acessar</Link></td>
            </tr>
        );
    }
}
